<template>
    <div>
        <div class="m-portlet left">
            <div class="m-portlet__body">
                <el-form>
                    <el-form-item>
                        <el-button style="width: 100%" @click="handleCreateClassHour()">
                            创建
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-select v-model="filter.section_id" placeholder="筛选校区" clearable
                                   @change="handleIndexClassHourList(1,10)">
                            <el-option
                                    v-for="item in sections"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
            </div>
        </div>
        <div class="m-portlet right" :style="{'height':(clientHeight-250)+'px'}">
            <div class="m-portlet__body">
                <table class="table" v-loading="loading">
                    <thead>
                    <tr>
                        <th>学期名</th>
                        <th>开始时间</th>
                        <th>结束时间</th>
                        <th>操作</th>
                    </tr>
                    </thead>
                    <tbody>
                    <tr v-for="(item,index) in classHourList" :key="index">
                        <td>{{item.name}}</td>
                        <td>{{item.start_date}}</td>
                        <td>{{item.end_date}}</td>

                        <td>
                            <el-button size="mini" @click="handleClassHour(item.id)">查看</el-button>
                            <el-button size="mini" @click="handleDeleteClassHour(item.id)" :loading="button_loading">删除</el-button>
                        </td>
                    </tr>
                    </tbody>
                </table>
                <div class="text-center m-t-10">
                    <el-pagination
                            @size-change="handleSizeChange"
                            @current-change="handleCurrentChange"
                            :current-page="currentPage"
                            :page-sizes="[10, 20, 50, 100]"
                            :page-size="10"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="total">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Index",
        data() {
            return {
                path: '/classHour',
                loading: true,
                button_loading: false,
                classHourList: {},
                currentPage: 1,
                currentPageSize: 10,
                total: 1,
                sections: [],
                grades:[],
                subjects:[],
                semesters:[],
                times:[{
                    id:'1',
                    name:'1小时'
                }],
                filter: {
                    section_id:'',
                },
                dialog_CreateClassHour:{
                    loading: true,
                    button_loading: false,
                },
                dialog_GetClassHourDetail:{
                    loading: true,
                    button_loading: false,
                    grades_classHour:[]
                },
            }
        },
        computed: {
            clientHeight() {
                return this.$store.state.config.clientHeight
            },
        },
        created() {
            this.handleCreate();
            this.handleIndexClassHourList();
            this.handleInit();
        },
        methods: {
            handleCreate() {
                this.$wApi.addListen(this.path, this.handleData);
            },
            handleData(event, data) {
                switch (event) {
                    case 'subscribe':
                        break;
                    case 'init':
                        this.sections=data.sections
                        break;
                    case 'list':
                        if (Object.keys(data.semesters.length > 0)){
                            this.classHourList = data.semesters
                        } else {
                            this.classHourList = new Object();
                        }
                        this.total = data.total;
                        this.loading = false;
                        break;
                    case 'classHour_format':
                        this.dialog_CreateClassHour.loading=false;
                        this.subjects=data.subjects
                        this.grades=data.grades
                        this.semesters=data.semesters
                        this.dialog_CreateClassHour.classHours=data.classHours
                        break;
                    case 'store_classHour':
                        this.$set(this.classHourList,data.semester.id,data.semester)
                        this.$message({
                            message: '创建成功',
                            type: 'success'
                        });
                        this.dialog_CreateClassHour.button_loading=false;
                        break;
                    case 'get_classHourDetail':
                        this.dialog_GetClassHourDetail.loading=false;
                        this.subjects=data.subjects
                        this.grades=data.grades
                        this.semesters=data.semesters
                        this.dialog_GetClassHourDetail.grades_classHour=data.classHours
                        break;
                    case 'update_classHour':
                        this.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        this.dialog_GetClassHourDetail.button_loading=false;
                        break;
                    case 'delete_classHour':
                        this.$delete(this.classHourList,data.semester_id)
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        this.button_loading=false;
                        break;
                }
            },
            handleInit() {
                this.$wApi.send(this.path, 'init');
            },
            handleIndexClassHourList(currentPage = 1, currentPageSize = 10) {
                this.$wApi.send(this.path, 'list', {
                    'currentPage': currentPage,
                    'currentPageSize': currentPageSize,
                    'section_id': this.filter.section_id,
                });
            },
            handleClassHour(semester_id) {
                this.$Win.openModal('Dialog_GetClassHourDetail', 1000, 800, '详情', {
                    'semester_id': semester_id
                });
            },
            handleDeleteClassHour(semester_id) {
                this.button_loading = true;
                this.$confirm('是否删除该学期课时?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$wApi.send(this.path, 'delete_classHour', {'semester_id': semester_id,});
                }).catch(() => {
                    this.button_loading = false;
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },
            handleCreateClassHour() {
                this.$Win.openModal('Dialog_CreateClassHour', 1000, 1000, '创建课时');
            },
            handleSizeChange(val) {
                this.currentPageSize = val;
                this.handleIndexClassHourList(this.currentPage, this.currentPageSize)
            },
            handleCurrentChange(val) {
                this.currentPage = val;
                this.handleIndexClassHourList(this.currentPage, this.currentPageSize)
            }
        }
    }
</script>

<style scoped>

</style>